import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Tên chỉ số",
    name: "tenChiSo",
    // rules: [{required: true, message: "Chưa nhập tên chỉ số"}],
  },
  {
    type: INPUT,
    label: "Trị số dưới bình thường",
    name: "chiSoBinhThuongDuoi",
    // rules: [{required: true, message: "Chưa nhập chỉ số"}],
  },
  {
    type: INPUT,
    label: "Trị số trên bình thường",
    name: "chiSoBinhThuongTren",
    // rules: [{required: true, message: "Chưa nhập chỉ số"}],
  },
  {
    type: INPUT,
    label: "Trị số bình thường",
    name: "chiSoBinhThuong",
    // rules: [{required: true, message: "Chưa nhập chỉ số"}],
  },
  {
    type: INPUT,
    label: "Trị số không bình thường",
    name: "chiSoKhongBinhThuong",
    // rules: [{required: true, message: "Chưa nhập chỉ số"}],
  },
  {
    type: INPUT,
    label: "Đơn vị",
    name: "donViTinh",
    // rules: [{required: true, message: "Chưa nhập đơn vị"}],
  },
];
export {dataFields};
